module.exports = __webpack_public_path__ + "img/ricardo.aed3cc90.gif";